export default __webpack_public_path__ + "static/ux-consultant-cover-2f6219044817766a0fcf27106904c1f4.png";